import { render, staticRenderFns } from "./StatisticsSettings.vue?vue&type=template&id=5b222b1b"
import script from "./StatisticsSettings.vue?vue&type=script&lang=js"
export * from "./StatisticsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports